import { ReactNode, useState } from 'react';
import TextModal, { type TextModalProps } from '../TextModal/TextModal';
import { Info } from '@volkswagen-onehub/icons-core';
import Box from '../Box/Box';

export type IconModalProps = {
  icon?: ReactNode;
  openCallback?: () => void;
  closeCallback?: () => void;
} & Omit<TextModalProps, 'closeModal'>;

const IconModal = (props: IconModalProps) => {
  const { icon, ...restProps } = props;
  const [showModal, setShowModal] = useState(false);

  return (
    <>
      <Box
        cursor="pointer"
        height="24px"
        onClick={(e) => {
          e.stopPropagation();
          setShowModal(!showModal);
        }}
      >
        {icon ?? <Info variant="default" />}
      </Box>

      {showModal && (
        <TextModal
          {...restProps}
          closeModal={(e) => {
            e.stopPropagation();
            setShowModal(false);
          }}
        />
      )}
    </>
  );
};

export default IconModal;
